<template>
  <div>
    <p style="text-align: center;">
      <!-- ASQMS 新闻与公告 -->
      <span class="systemFont1">{{ $t("newsAnncmnt.asqmsNewsAnncmnt") }}</span>
    </p>

    <el-row style="top: 17px;">
      <el-col :span="22" :offset="1" style="text-align: left;">
        <!-- 查询 -->
        <el-form
          :model="queryForm"
          label-position="right"
          ref="queryForm"
          label-width="80px"
          class="systemFont1"
        >
          <el-row>
            <!-- 标题 -->
            <el-col :span="6">
              <el-form-item :label="$t('newsAnncmnt.title')">
                <el-input
                  name="queryForm.title"
                  type="text"
                  size="courseSelect"
                  v-model="queryForm.title"
                  maxlength="255"
                  clearable
                  :placeholder="$t('newsAnncmnt.titleName')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col style="width: 200px;">
              <!-- 查询 -->
              <el-button
                type="submit"
                class="submitButton"
                style="margin-left:15px"
                @click="init(true)"
                ><span>{{ $t("common.query") }}</span>
              </el-button>
              <!-- 重置 -->
              <el-button type="submit" class="buttonWidth" @click="reset"
                ><span>{{ $t("common.reset") }}</span>
              </el-button>
            </el-col>
          </el-row>
        </el-form>

        <el-row>
          <el-col>
            <!-- 新增 -->
            <el-button
              type="submit"
              class="submitButton"
              @click="
                $router.push({
                  path: '/views/Asqms/views/NewsAnncmnt/Edit',
                  query: {
                    titleHead: 'add',
                    //模糊查询
                    queryForm: queryForm,
                    // 当前页
                    currentPageCo: currentPageCo,
                    // 页数
                    pageSizeCo: pageSizeCo,
                    // 总数
                    totalCo: totalCo
                  }
                })
              "
              ><span>{{ "+" + $t("common.add") }}</span>
            </el-button></el-col
          >
        </el-row>
      </el-col>
    </el-row>
    <!-- 新闻与公告一览 -->
    <el-row style="top: 17px ;">
      <el-col :span="22" :offset="1">
        <el-table :data="tableData">
          <!-- 标题名称zh -->
          <el-table-column
            fixed="left"
            width="auto"
            prop="title"
            :label="$t('newsAnncmnt.titleZh')"
            align="left"
          ><template slot-scope="scope">
            <span>{{ scope.row.title.split(',')[0]}}</span>
          </template>
        </el-table-column>
          <!-- 标题名称en -->
          <el-table-column
            fixed="left"
            width="auto"
            prop="title"
            :label="$t('newsAnncmnt.titleEn')"
            align="left"
          ><template slot-scope="scope">
            <span>{{ scope.row.title.split(',')[1]}}</span>
          </template></el-table-column>
          <!-- 状态 -->
          <el-table-column
            fixed="left"
            width="100px"
            prop="status"
            :label="$t('newsAnncmnt.status')"
            align="center"
          >
            <template slot-scope="scope">
              <span
                :style="
                  scope.row.status === 0 ? 'color:#FD5B4D' : 'color:#08C846'
                "
                >{{
                  scope.row.status === 0
                    ? $t("newsAnncmnt.toBePublished")
                    : $t("newsAnncmnt.published")
                }}</span
              >
            </template>
          </el-table-column>
          <!-- 创建时间 -->
          <el-table-column
            fixed="left"
            width="150px"
            prop="createTime"
            :label="$t('newsAnncmnt.creationTime')"
            align="center"
          >
            <template slot-scope="scope">
              {{ dateFormat(scope.row.createTime) }}
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            fixed="right"
            :label="$t('common.operation')"
            align="center"
            width="150px"
          >
            <template slot-scope="scope">
              <!-- 发布 -->
              <el-button
                v-if="scope.row.status === 0"
                size="text"
                @click="updateNewsAnncmntStatus(scope.row, 1)"
                >{{ $t("newsAnncmnt.publish") }}
              </el-button>
              <!-- 编辑 -->
              <el-button
                size="text"
                @click="
                  $router.push({
                    path: '/views/Asqms/views/NewsAnncmnt/Edit',
                    query: {
                      titleHead: 'edit',
                      id: scope.row.id,
                      newsNo: scope.row.newsNo,
                      //模糊查询
                      queryForm: queryForm,
                      // 当前页
                      currentPageCo: currentPageCo,
                      // 页数
                      pageSizeCo: pageSizeCo,
                      // 总数
                      totalCo: totalCo
                    }
                  })
                "
                >{{ $t("common.edit") }}
              </el-button>
              <!-- 删除 -->
              <el-button
                size="text"
                style="color: #FD5B4D"
                @click="updateNewsAnncmntStatus(scope.row, 2)"
                >{{ $t("common.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: right; margin: 20px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPageCo"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSizeCo"
                layout="total, sizes, prev, pager, next"
                :total="totalCo"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "OrderManagement",
  data() {
    return {
      userId: "",
      // 一览数据
      tableData: [],
      // 查询条件
      queryForm: {
        title: ""
      },
      // 当前页
      currentPageCo: 1,
      // 每页件数
      pageSizeCo: 10,
      totalCo: 0
    };
  },
  methods: {
    // 格式化发起日期
    dateFormat(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD HH:mm");
      } else {
        return "-";
      }
    },
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSizeCo = val;
      this.currentPageCo = 1;
      //判断更改页码是否需要查询
      if (this.tableData == undefined || this.tableData.length <= 0) {
        return;
      }
      this.init(false);
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPageCo = val;
      this.init(false);
      // console.log(`当前页: ${val}`);
    },
    // 初始化一览数据
    init(val) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      if (val) {
        // 分页数据初始化
        this.currentPageCo = 1;
        this.totalCo = 0;
      }
      let url = "/api/newsAnncmnt/getList";
      this.$http
        .post(url, {
          //模糊查询
          ...this.queryForm,
          // 当前页
          currentSizeCo: (this.currentPageCo - 1) * this.pageSizeCo,
          // 页数
          pageSizeCo: this.pageSizeCo,
          // 总数
          totalCo: this.totalCo
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.tableData = [];
            } else {
              // 总数取值
              this.totalCo = response.data.data[0].totalCo;
              // 渲染页面
              this.tableData = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 重置搜索表单
    reset() {
      this.queryForm = {
        title: ""
      };
      this.init(true);
    },
    // 发布、删除
    updateNewsAnncmntStatus(row, status) {
      this.$confirm(
        status === 1
          ? this.$t("newsAnncmnt.msg1")
          : this.$t("newsAnncmnt.msg2"),
        {
          // 确定
          confirmButtonText: this.$t("common.confirm"),
          // 取消
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }
      ).then(() => {
        let url = "/api/newsAnncmnt/updateNewsAnncmntStatus";
        this.$http
          .post(url, {
            ...row,
            status,
            updateUser: localStorage.userId
          })
          .then(rep => {
            this.$message({
              type: "success",
              message: this.$t("p0433.operationSuccess")
            });
            this.init(false);
          })
          .catch(err => {
            console.log(err);
          });
      });
    }
  },
  mounted() {
    console.log(this.$route.query);
    if (this.$route.query.currentPageCo) {
      this.currentPageCo = Number(this.$route.query.currentPageCo);
    }
    if (this.$route.query.totalCo) {
      this.totalCo = Number(this.$route.query.totalCo);
    }
    if (this.$route.query.pageSizeCo) {
      this.pageSizeCo = Number(this.$route.query.pageSizeCo);
    }
    if (this.$route.query.queryForm) {
      this.queryForm = this.$route.query.queryForm;
    }
    let path = this.$route.path; //先获取路由路径
    this.$router.replace(path); //再跳转路由路径，query参数没带过去，所以被清除了
    this.init(false);
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

.preSpecificContent {
  font-family: "微软雅黑", sans-serif;
  font-weight: 400;
  color: #666666;
  font-size: 14px;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0px;
}

>>> .el-input--courseSelect .el-input__inner {
  height: 32px !important;
}

.el-button--submit {
  height: 32px;
}

>>> .buttonWidth {
  width: 80px;
  height: 32px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}

//弹窗样式
>>> .roll-dialog .el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(80vh - 140px);
}

//弹窗样式
>>> .add_roll-dialog {
  .el-dialog__body {
    padding: 3px 30px;
    overflow-y: auto;
    height: calc(90vh - 140px);
  }
}

.submitButton {
  width: 80px;
  height: 32px;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/Asqms/views/NewsAnncmnt/Index.vue